import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { Avatar } from "../Avatar/Avatar.js";
import { Dropdown } from "../Dropdown/Dropdown.js";
/* empty css             */
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/UserMenu/UserMenu.tsx
/** The trigger: avatar, name and role, and a caret. Dropdown gives it its ARIA. */
var Trigger = forwardRef(function Trigger({ name, roleLabel, avatarSrc, compact, className, ...rest }, ref) {
	return /* @__PURE__ */ jsxs("button", {
		ref,
		type: "button",
		...rest,
		"aria-label": roleLabel ? `${name}, ${roleLabel}` : name,
		className: cx("ds-user-menu", compact === true && "ds-user-menu--compact", compact === false && "ds-user-menu--full", className),
		children: [
			/* @__PURE__ */ jsx(Avatar, {
				name,
				src: avatarSrc,
				size: "sm",
				decorative: true
			}),
			/* @__PURE__ */ jsxs("span", {
				className: "ds-user-menu__text",
				children: [/* @__PURE__ */ jsx("span", {
					className: "ds-user-menu__name",
					children: name
				}), roleLabel && /* @__PURE__ */ jsx("span", {
					className: "ds-user-menu__role",
					children: roleLabel
				})]
			}),
			/* @__PURE__ */ jsx("span", {
				className: "ds-user-menu__caret",
				"aria-hidden": "true",
				children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down" })
			})
		]
	});
});
/**
* The signed-in user at the top right: avatar, name and role, opening a menu headed by
* their name and email, with Sign out. Put it in TopBar's `actions`.
*/
function UserMenu({ name, email, roleLabel, avatarSrc, items = [], onSignOut, signOutLabel = "Sign out", compact, defaultOpen = false, className }) {
	return /* @__PURE__ */ jsx(Dropdown, {
		align: "end",
		defaultOpen,
		trigger: /* @__PURE__ */ jsx(Trigger, {
			name,
			roleLabel,
			avatarSrc,
			compact,
			className
		}),
		sections: [{
			header: /* @__PURE__ */ jsxs("span", {
				className: "ds-user-menu__header",
				children: [/* @__PURE__ */ jsx("span", {
					className: "ds-user-menu__header-name",
					children: name
				}), email && /* @__PURE__ */ jsx("span", {
					className: "ds-user-menu__header-email",
					children: email
				})]
			}),
			items: [...items, {
				label: signOutLabel,
				icon: "log-out",
				danger: true,
				onClick: onSignOut
			}]
		}]
	});
}
//#endregion
export { UserMenu };

//# sourceMappingURL=UserMenu.js.map